import logo from '../imgs/gersem-logo.png';

export default function Footer() {
	const currentDate = new Date().getFullYear();
	return (
		<footer>
			<div className="container">
				<div className="logo">
					<div>
						<img src={logo} alt="Gersem" /><span>Gersem</span>
					</div>
					<p>Transforming Businesses, Empowering Futures</p>
					<a href="mailto:partners@gersem.com">partners@gersem.com</a>
				</div>
			</div>

			<p className="txt-center">&copy; Gersem {currentDate}. All right reserved.</p>
		</footer>
	);
}
